<template>
	<layout-admin-form class="app-admin admin-watch-form" :action="action">
		<div slot="breadcrumbs"><admin-breadcrumbs :breadcrumbs="breadcrumbs"/></div>
		<span slot="header">{{ title }}</span>
		<spinner v-if="loading"/>
		<error-box v-else-if="error" :error="error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-text v-model="model.imei" name="device_imei" placeholder="IMEI" rules="required"/>
			<error-box v-if="form_error" :error="form_error"/>
			<button type="submit" class="btn btn-primary btn-round">Save</button>
		</form>
	</layout-admin-form>
</template>

<script>
import LayoutAdminForm from '../LayoutAdminForm'
import AdminBreadcrumbs from '../AdminBreadcrumbs'
export default {
	components: {
		LayoutAdminForm,
		AdminBreadcrumbs
	},
	props: [
		'device_id',
		'data',
		'action'
	],
	data () {
		return {
			title: 'Device',
			loading: false,
			error: null,
			form_error: null,
			model: {
				imei: ''
			}
		}
	},
	computed: {
		breadcrumbs () {
			return [
				{
					title: 'Device Whitelist',
					name: 'AdminDeviceList'
				},
				{
					title: `${this.action} ${this.title}`
				}
			]
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			switch (this.action) {
				case 'add':
					this.addDevice()
					break
				case 'edit':
					this.editDevice()
					break
				default:
					this.$log.warn('admin', 'action not set')()
			}
		},
		getDevice () {
			this.loading = true
			this.$api.devices.admin.whitelist.get(this, this.device_id)
				.then(response => {
					this.$log.info('admin', 'devices.admin.whitelist.get OK', response)()
					this.model = response.body
				}).catch(errors => {
					this.$log.error('admin', 'devices.admin.whitelist.get ERROR', errors)()
					this.error = errors
				}).finally(() => {
					this.loading = false
				})
		},
		addDevice () {
			this.$api.devices.admin.whitelist.add(this, this.model)
				.then(response => {
					this.$log.info('admin', 'devices.admin.whitelist.add OK', response)()
					this.$router.push({ name: 'AdminDeviceList' })
				}).catch(errors => {
					this.$log.error('admin', 'devices.admin.whitelist.add ERROR', errors)()
					this.form_error = errors
				})
		},
		editDevice () {
			this.$api.devices.admin.whitelist.edit(this, this.model)
				.then(response => {
					this.$log.info('admin', 'devices.admin.whitelist.edit OK')()
					this.$router.push({ name: 'AdminDeviceList' })
				}).catch(errors => {
					this.$log.error('admin', 'devices.admin.whitelist.edit ERROR', errors)()
					this.form_error = errors
				})
		}
	},
	beforeCreate () {
		this.$title('Device Form')
	},
	mounted () {
		if (this.action === 'edit') {
			if (this.data === undefined) {
				this.getDevice()
			} else {
				this.model = this.data
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/devices/DeviceForm.vue